export default function formatName(context, name) {
  var sectionPrefix = context._reduxForm.sectionPrefix;

  return !sectionPrefix ? name : sectionPrefix + "." + name;
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/util/prefixName.js
// module id = 78
// module chunks = 0